export default __webpack_public_path__ + "static/media/future_messages.d65c00ce.svg";